export const getStyle = () => ({
  imagePlaceholder: {
    width: 115,
    height: 98,
    display: 'block',
    border: '2px solid #1079d1',
    objectFit: 'cover',
  },
  portraitWithImage: {
    position: 'relative',

    '& .image-edit': {
      position: 'absolute',
      border: 'none',
      height: 32,
      width: 32,
      borderRadius: '50%',
      backgroundColor: 'rbga(255,255,255,0.5)',
      left: 17,
      top: 57,
      '&:hover': {
        backgroundColor: '#106ebeff',
        '&:before': {
          color: '#fff',
        },
      },
    },
    '& .image-delete': {
      position: 'absolute',
      border: 'none',
      height: 32,
      width: 32,
      borderRadius: '50%',
      backgroundColor: 'rbga(255,255,255,0.5)',
      left: 60,
      top: 57,
      '&:hover': {
        backgroundColor: '#106ebeff',
        '&:before': {
          color: '#fff',
        },
      },
    },
    '& .image-add': {
      height: 32,
      width: 122,
    },
  },
});
